(function ($) {
    
    function initSlider() {
        $('.slider').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 6000,
            dots: false,
            arrows: true,
            infinite: true,
            fade: true,
            adaptiveHeight: true
        });
        
        $('.testimonial-slider').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 6000,
            dots: false,
            arrows: true,
            infinite: true,
            fade: true,
            adaptiveHeight: false
        });
    }

	/* Document Ready */
	$(document).ready(function() {

        initSlider();

	});

})(jQuery);